import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/types';

export const useReturnTrackingFeature = () => {
    const resellerDetails = useSelector((state: RootState) => state?.resellerReducer?.resellerDetails);

    const isReturnTrackingEnabled = useMemo(() => {
        // Return false if resellerDetails is not loaded yet
        if (resellerDetails?.status !== 'Loaded' || !resellerDetails?.value) {
            return false;
        }

        return resellerDetails.value.trackingDetailsEnabled === true;
    }, [resellerDetails]);

    return {
        isReturnTrackingEnabled,
    };
};
